import React from 'react';
import { IInputStyled, InputStyled } from '../TextInput';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

const NumberFormatComponent: React.FunctionComponent<IInputStyled & NumberFormatProps> = (props) => {
  const { errorText, isRequired, hasAppendIcon, showErrorHighlight, hasPrependIcon, isOpen, ...rest } = props;
  return <NumberFormat {...rest} />;
};

export const NumberInputStyled = InputStyled.withComponent(NumberFormatComponent);
